var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('div',{},[_c('img',{staticClass:"w-full custborderradius",attrs:{"src":"https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/care%20support%20service%20-%20looking%20for%20a%20caregiver%20saathi.jpg","alt":"swiper-img"}})])])
}]

export { render, staticRenderFns }